// Пропуск в хранилище браузера: что от него осталось панели (26 сен 2026).
//
// Старый вход по почте и паролю держал пропуска в localStorage и обновлял их по сроку; вход и
// обновление сняты (ленды З и З2 спеки docs/superpowers/specs/2026-09-26-admin-passkey-access-
// verification.md) — админ входит ключом доступа, живая сессия в куке HttpOnly. Здесь осталось:
//   • имена ключей хранилища старого входа — панель их не читает, только стирает, чтобы не лежали;
//   • срок пропуска из JWT — шина событий не открывает канал истёкшим пропуском мини-аппа.

export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';

/** exp из JWT в миллисекундах; null — не JWT или без exp. Подпись не проверяем: это срок, не доверие. */
export function decodeJwtExpMs(token: string | null | undefined): number | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    const exp = (JSON.parse(json) as { exp?: unknown }).exp;
    return typeof exp === 'number' && Number.isFinite(exp) ? exp * 1000 : null;
  } catch {
    return null;
  }
}
